import React, {Fragment} from 'react';
import {Col, Row} from "react-bootstrap";
import {formatCurrency} from "../functions/formatCurrency";

function CartTotals({subtotal, rebateAmount = 0}) {

  const gst = subtotal * 0.1;
  const finalTotal = subtotal + gst - rebateAmount;

  return (
    <Fragment>
      <Row className="fw-bold">
        <Col xs={6} className="text-end">
          SubTotal:<br/>
        </Col>
        <Col xs={6} className="text-end">
          {formatCurrency(subtotal)}<br/>
        </Col>
      </Row>

      <Row className="fw-bold">
        <Col xs={6} className="text-end">
          GST:<br/>
        </Col>
        <Col xs={6} className="text-end">
          {formatCurrency(gst)}<br/>
        </Col>
      </Row>

      {rebateAmount > 0 && (
        <Row className="fw-bold">
          <Col xs={6} className="text-end">
            STC Rebate:<br/>
          </Col>
          <Col xs={6} className="text-end text-success">
            -{formatCurrency(rebateAmount)}<br/>
          </Col>
        </Row>
      )}

      <Row className="fw-bold border rounded pt-2 pb-2">
        <Col xs={6} className="text-end">
          Total:<br/>
        </Col>
        <Col xs={6} className="text-end">
          {formatCurrency(finalTotal)}
        </Col>
      </Row>
    </Fragment>
  );
}

export default CartTotals;